import { FactoryProvider } from '@angular/core';
import { DropdownAllOptionService } from '@lib/i18n/data-access';
import { DropdownOption, NOT_SELECTED_FILTER_TOKEN } from '@platform-workspace/design-system';

export const provideNotSelectedItemProvider = (): FactoryProvider => {
  return {
    provide: NOT_SELECTED_FILTER_TOKEN,
    useFactory: (dropdownAllOptionService: DropdownAllOptionService): DropdownOption => dropdownAllOptionService.allOption(),
    deps: [DropdownAllOptionService],
  };
};
